import { DynamicContent, DynamicContentResponse } from 'types/Home/getDynamicContent';

export const transformGetDynamicContent = (
  response: DynamicContentResponse,
): DynamicContent => ({
  interval: response.data.intervalo,
  transitionType: response.data.transicao_tipo,
  autoplay: response.data.autoplay,
  images: response.data.imagens,
});

export const mock = 4;
